// @generated-imports
import { applyFiltersAndRender, escapeHTML, findGameById, updateFavCountBadge } from './app.js';
import { CONFIG, dom, state } from './core.js';
import { announce } from './gamepad.js';
import { isLocalRomId } from './library.js';
// @generated-imports
/* ===========================================================================
   FAVORITOS DO USUÁRIO, JOGADOS RECENTEMENTE E PERSISTÊNCIA DE FILTROS
   ---------------------------------------------------------------------------
   Tudo em localStorage: o usuário marca os favoritos dele com o coração no
   card (o antigo campo "favorite" de curadoria do roms.json foi aposentado).
   ======================================================================== */

function loadFavorites() {
  try {
    const raw = JSON.parse(localStorage.getItem(CONFIG.localStorageFavoritesKey) || '[]');
    state.favorites = new Set(Array.isArray(raw) ? raw.map(String) : []);
  } catch (_) {
    state.favorites = new Set();
  }
}

function saveFavorites() {
  try {
    localStorage.setItem(CONFIG.localStorageFavoritesKey, JSON.stringify([...state.favorites]));
  } catch (_) { /* armazenamento cheio/bloqueado: segue sem persistir */ }
}

function isFavorite(id) {
  return state.favorites.has(id);
}

function toggleFavorite(id, button) {
  const game = findGameById(id);
  if (!game) return;

  const nowFavorite = !state.favorites.has(id);
  if (nowFavorite) state.favorites.add(id);
  else state.favorites.delete(id);
  saveFavorites();
  updateFavCountBadge();

  // Atualiza o botão in-place — sem re-renderizar o grid inteiro, para não
  // perder a posição de scroll nem os lotes já carregados.
  if (button) {
    button.classList.toggle('is-active', nowFavorite);
    button.setAttribute('aria-pressed', String(nowFavorite));
    button.textContent = nowFavorite ? '♥' : '♡';
    const label = nowFavorite ? 'Remover dos favoritos' : 'Adicionar aos favoritos';
    button.setAttribute('aria-label', `${label}: ${game.title}`);
    button.title = label;
  }

  announce(nowFavorite
    ? `${game.title} adicionado aos favoritos.`
    : `${game.title} removido dos favoritos.`);

  // Só re-filtra quando o card deixaria de pertencer à lista atual.
  if (state.favoritesOnly && !nowFavorite) applyFiltersAndRender();
}

function loadPlayCounts() {
  try {
    const raw = JSON.parse(localStorage.getItem(CONFIG.localStoragePlayCountsKey) || '{}');
    state.playCounts = (raw && typeof raw === 'object') ? raw : {};
  } catch (_) {
    state.playCounts = {};
  }
}

function bumpPlayCount(id) {
  state.playCounts[id] = (state.playCounts[id] || 0) + 1;
  try {
    localStorage.setItem(CONFIG.localStoragePlayCountsKey, JSON.stringify(state.playCounts));
  } catch (_) { /* noop */ }
}

function getPlayCount(id) {
  return state.playCounts[id] || 0;
}

function loadRecentGames() {
  try {
    const raw = JSON.parse(localStorage.getItem(CONFIG.localStorageRecentKey) || '[]');
    state.recentGames = Array.isArray(raw) ? raw.map(String) : [];
  } catch (_) {
    state.recentGames = [];
  }
}

function addRecentGame(id) {
  state.recentGames = [id, ...state.recentGames.filter((entry) => entry !== id)]
    .slice(0, CONFIG.recentGamesLimit);
  try {
    localStorage.setItem(CONFIG.localStorageRecentKey, JSON.stringify(state.recentGames));
  } catch (_) { /* noop */ }
}

function renderRecentGames() {
  const games = state.recentGames
    .map((id) => findGameById(id) || state.localRoms.get(id))
    .filter(Boolean);

  dom.recentStrip.classList.toggle('is-hidden', games.length === 0);
  dom.recentChips.innerHTML = '';

  games.forEach((game) => {
    const chip = document.createElement('button');
    chip.type = 'button';
    chip.className = 'chip';
    chip.dataset.recentId = game.id;
    const local = isLocalRomId(game.id);
    // Selo "local": sem ele, o chip de uma ROM avulsa era idêntico ao de um
    // jogo do catálogo — e o usuário esperava capa/descrição que não existem.
    chip.innerHTML = `<span aria-hidden="true">▶</span> ${escapeHTML(game.title)}${local ? ' <span class="chip-badge">local</span>' : ''}`;
    chip.title = local
      ? `Jogar ${game.title} (ROM local • ${game.system})`
      : `Jogar ${game.title} (${game.system})`;
    dom.recentChips.appendChild(chip);
  });
}

function persistFilters() {
  try {
    localStorage.setItem(CONFIG.localStorageFiltersKey, JSON.stringify({
      genre: state.genre,
      system: state.system,
      sort: state.sort,
      favoritesOnly: state.favoritesOnly,
      view: state.view,
    }));
  } catch (_) { /* noop */ }
}

function restoreFilters() {
  try {
    const saved = JSON.parse(localStorage.getItem(CONFIG.localStorageFiltersKey) || 'null');
    if (!saved || typeof saved !== 'object') return;
    if (typeof saved.genre === 'string') state.genre = saved.genre;
    if (typeof saved.system === 'string') state.system = saved.system;
    if (typeof saved.sort === 'string') state.sort = saved.sort;
    state.favoritesOnly = Boolean(saved.favoritesOnly);
    if (saved.view === 'screenshot' || saved.view === 'cover') state.view = saved.view;
  } catch (_) { /* noop */ }
}

// @generated-exports
export { addRecentGame, bumpPlayCount, getPlayCount, isFavorite, loadFavorites, loadPlayCounts, loadRecentGames, persistFilters, renderRecentGames, restoreFilters, saveFavorites, toggleFavorite };
// @generated-exports
